import { KeyValueEnum } from "@/main/models/common";
import { SchedulerUsersActionTypes, SchedulerUsersTypes } from "./schedulerUsersTypes";
import { ProcurementReportScheduleRequest } from "@/main/models/request";

export function getSchedulerUsers(request: ProcurementReportScheduleRequest): SchedulerUsersActionTypes {
	return {
		type: SchedulerUsersTypes.GET_SCHEDULER_USERS,
		payload: request,
	};
}

export function saveSchedulerUsers(
	data: KeyValueEnum[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): SchedulerUsersActionTypes {
	return {
		type: SchedulerUsersTypes.SAVE_SCHEDULER_USERS,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerSchedulerUsers(): SchedulerUsersActionTypes {
	return {
		type: SchedulerUsersTypes.RESET_REDUCER_SCHEDULER_USERS,
	};
}
